/***
 * Created on 2023/7/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";

const INTEREST_ITEM = {
    my_interests_for_business: "@For Business@",
    my_interests_soho: "@For Family & SOHO@",
    my_interests_data_protection: "@Data Protection@",
    my_interests_cloud: "@Cloud@",
    my_interests_networking: "@Networking@",
    my_interests_surveillance: "@Video Surveillance & Premises Security@",
    my_interests_product_security: "@Product Security@",
    my_interests_content_creation: "@Content Creator@",
    my_interests_monthly_news: "@Monthly News@"
}

function InterestItem({item, subscribed, setSubscribed}) {
    const [checked, setChecked] = useState(false);
    const { t } = useTranslation();

    const onChanged = (e) => {
        setChecked(prev => !prev);
        setSubscribed(prev => {
            if (prev.includes(item.value)) {
                return prev.filter(i => i !== item.value)
            }
            return [...prev, item.value];
        });
    }

    useEffect(() => {
        setChecked(subscribed?.includes(item.value));
    }, [subscribed, item?.value]);

    return (
        <div className={`subscriptions__item ${checked ? 'active' : ''}`}>
            <div className="comp-checkbox">
                <label className="q-checkbox">
                    <input type="checkbox" name="checkbox-checked" checked={checked} onChange={onChanged}/>
                    {t(INTEREST_ITEM[item.display_text])}
                </label>
            </div>
        </div>
    );
}

export default InterestItem;